import {taskDueDateStatus, taskPriority, taskStatus} from "../../../../utils/constants.js";

const getTaskStatusOptions = (() => {
  const statusOptions = Object.keys(taskStatus).map(status => ({label: status, value: status}))
  statusOptions.unshift({label: 'Any', value: ''})

  return statusOptions
})

export const taskStatusOptions = getTaskStatusOptions()

const getTaskPriorityOptions = (() => {
  const priorityOptions = Object.keys(taskPriority).map(priority => ({label: priority, value: priority}))
  priorityOptions.unshift({label: 'Any', value: ''})

  return priorityOptions
})

export const taskPriorityOptions = getTaskPriorityOptions()

const getTaskDueDateStatusOptions = (() => {
  const dueDateStatusOptions = Object.keys(taskDueDateStatus).map(status => ({label: status.replaceAll('_', ' '), value: status}))
  dueDateStatusOptions.unshift({label: 'Any', value: ''})

  return dueDateStatusOptions
})

export const taskDueDateStatusOptions = getTaskDueDateStatusOptions()
